// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchFieldDateRangeStyles } from "@steiner/App/Components/ReorderPad/SearchFieldDateRange";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

searchFieldDateRangeStyles.datePickersGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

searchFieldDateRangeStyles.datePickersGridContainer = {
    gap: 12,
};

searchFieldDateRangeStyles.searchFieldWrapper = {
    wrapper: {
        width: [12, 6, 6, 6, 6],
        css: css`
            & > div {
                flex: 1;
            }
        `,
    },
};

searchFieldDateRangeStyles.label = {
    size: 12,
    lineHeight: "17px",
    weight: fontConfig.weight.semiBold,
    css: css`
        margin-bottom: 4px;
    `,
};

searchFieldDateRangeStyles.fromDate = {
    mergeCss: true,
    cssOverrides: {
        inputSelect: css`
            height: 34px;
        `,
    },
};

searchFieldDateRangeStyles.toDate = {
    mergeCss: true,
    cssOverrides: {
        inputSelect: css`
            height: 34px;
        `,
    },
};
